export * from './LabeledIcon';
export * from './LabeledIcon.styles';
